import {
  TipoDomandaDTO,
  getFrontTipiDomanda,
  getGetFrontTipiDomandaQueryOptions,
} from '@framework/api-client';
import { AsyncSelectInput, IBaseAsyncSelectInputProps } from '@framework/form';
import React from 'react';

export interface IInquiryTypeSelectInputProps
  extends IBaseAsyncSelectInputProps {}

export function InquiryTypeSelectInput(props: IInquiryTypeSelectInputProps) {
  const { ...otherProps } = props;
  return (
    <AsyncSelectInput
      {...otherProps}
      queryFn={getFrontTipiDomanda}
      initialParams={{ ordinamenti: ['titolo'] }}
      queryOptions={getGetFrontTipiDomandaQueryOptions}
      searchByField="titolo"
      asOption={(inquiryType: TipoDomandaDTO) => ({
        value: inquiryType.idGruppo!,
        label: inquiryType.titolo!,
      })}
    />
  );
}
